// extracted by mini-css-extract-plugin
module.exports = {"section":"WhatsCooking_section__EzC3e","carouselSection":"WhatsCooking_carouselSection__thnt9"};